import { BlockedUsers } from '@/screens/blocked-users';

export default function BlockedUsersRoute() {
  return <BlockedUsers />;
}
